<template>
  <div>
    <div id="experience" class="row single-exp">
      <div align="left">
        <div class="resume-view-header">{{ work.training_title }}</div>
        <div>
          <span>{{ work.institution_name }}</span>
          <span> {{ work.location_name }} </span>
        </div>
        <div class="">
          {{ work.training_year }}
          <span>({{ work.training_duration + " Months" }})</span>
        </div>
        <div class="resume-view-details">
          {{work.training_description}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "experience-card",
  components: {},
  props: {
    job: Object,
    index: Number
  },
  data: function() {
    return {
      work: this.job,
      check: 0,
      overflowed: false,
      truncateView: true
    };
  }
};
</script>

<style scoped>
.image-wrapper {
  text-align: left;
  margin-top: 1rem;
}
.num-wrapper {
  color: #3d4249;
  border: 0.1rem solid #3d4249;
  border-radius: 50%;
  padding: 0.1rem 0.6rem;
}
.single-exp {
  padding: 1rem 0;
}
.exp-details {
  padding: 0;
  text-align: left;
}
.company {
  font-size: 16px;
  letter-spacing: 0;
}
.designation {
  padding: 0;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0;
}
.location {
  font-weight: lighter;
  font-size: 14px;
  letter-spacing: 0;
}
.description {
  font-size: 14px;
  letter-spacing: 0;
  width: 550px;
  overflow: hidden;
}
.exp-details-years {
  padding: 2px 0 0 2%;
  font-weight: lighter;
  font-size: 14px;
  letter-spacing: 0;
}
.more-less {
  color: #207688;
}
</style>
